// extracted by mini-css-extract-plugin
export var card = "_a4-0";
export var failedIcon = "_a4-4";
export var failedIconBadge = "_a4-3";
export var icon = "_a4-1";
export var successIcon = "_a4-2";